import React, { useEffect, useState } from "react"
import Helmet from "react-helmet"

import { Button, Input, RichText } from "components"

function InvestorRelations({ content, secondaryContent }) {
  const [firstName, setFirstName] = useState("")
  const [firstNameError, setFirstNameError] = useState("")
  const [lastName, setLastName] = useState("")
  const [lastNameError, setLastNameError] = useState("")
  const [businessName, setBusinessName] = useState("")
  const [businessNameError, setBusinessNameError] = useState("")
  const [email, setEmail] = useState("")
  const [emailError, setEmailError] = useState("")

  // fix SSR & timestamp interval issues with ReCAPTCHA
  const [mounted, setMounted] = useState(false)
  useEffect(() => {
    setMounted(true)
    function timestamp() {
      var response = document.getElementsByName("g-recaptcha-response")
      if (response[0] == null || response[0].value.trim() == "") {
        var elems = JSON.parse(
          document.getElementsByName("captcha_settings")[0].value
        )
        elems["ts"] = JSON.stringify(new Date().getTime())
        document.getElementsByName(
          "captcha_settings"
        )[0].value = JSON.stringify(elems)
      }
    }
    let interval = setInterval(timestamp, 500)
    return function cleanup() {
      clearInterval(interval)
    }
  }, [])

  return (
    <div className="wrapper default-grid">
      {mounted && (
        <Helmet>
          <script
            src={
              "https://www.google.com/recaptcha/api.js?testQuery=" +
              Math.random()
            }
          />
        </Helmet>
      )}
      <div className="pt-24 space-y-10 col-span-full md:col-span-10 md:col-start-2 md:pt-30 md:space-y-14 md:pb-24">
        {content && <RichText content={content} size="large" />}
        <form
          className="default-grid gap-y-6 md:gap-y-8"
          noValidate
          action="https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8"
          method="POST"
          onSubmit={e => {
            let error
            setFirstNameError("")
            setLastNameError("")
            setBusinessNameError("")
            setEmailError("")
            if (!firstName) {
              setFirstNameError("Please provide your first name")
              error = true
            }
            if (!lastName) {
              setLastNameError("Please provide your last name")
              error = true
            }
            if (!businessName) {
              setBusinessNameError("Please provide your business name")
              error = true
            }
            if (!email || !/(.+)@(.+){2,}\.(.+){2,}/.test(email)) {
              setEmailError("Please provide a valid email address")
              error = true
            }
            // if error, prevent default form submission
            if (error) {
              e.preventDefault()
            }
          }}
        >
          <div className="col-span-full md:col-span-6">
            <Input
              label="First name"
              name="first_name"
              required="true"
              type="text"
              id="first_name"
              value={firstName}
              onChange={e => {
                setFirstName(e.target.value)
              }}
              error={firstNameError}
            />
          </div>
          <div className="col-span-full md:col-span-6">
            <Input
              label="Last name"
              name="last_name"
              required="true"
              type="text"
              id="last_name"
              value={lastName}
              onChange={e => {
                setLastName(e.target.value)
              }}
              error={lastNameError}
            />
          </div>
          <div className="col-span-full md:col-span-6">
            <Input
              label="Business name"
              name="company"
              type="text"
              id="company"
              required="true"
              value={businessName}
              onChange={e => {
                setBusinessName(e.target.value)
              }}
              error={businessNameError}
            />
          </div>
          <div className="col-span-full md:col-span-6">
            <Input
              label="Email address"
              name="email"
              required="true"
              pattern="[^@\s]+@[^@\s]+\.[^@\s]+"
              type="email"
              id="email"
              value={email}
              onChange={e => {
                setEmail(e.target.value)
              }}
              error={emailError}
            />
          </div>
          <div className="col-span-full md:col-span-6">
            <div
              class="g-recaptcha"
              data-sitekey="6LcbyVQbAAAAADNa7lAKwOZOD-x-TSbmgVK2VGzA"
            ></div>
          </div>
          <div className="col-span-full">
            <Button
              label="Submit"
              type="submit"
              appearance="primary"
              onClick={() => {}}
            />
            <input
              type="hidden"
              name="captcha_settings"
              value='{"keyname":"websitekey","fallback":"true","orgId":"00D4x0000016btB","ts":""}'
            />
            <input type="hidden" name="oid" value="00D4x0000016btB" />
            <input
              type="hidden"
              name="retURL"
              value="https://www.hearthsidefoods.com/thank-you/"
            />
            <input
              type="hidden"
              id="Source__c"
              name="Source__c"
              value="investors"
            />
          </div>
        </form>
        <div className="relative grid-cols-10 px-6 py-10 -mx-6 bg-lightBlue md:py-14 default-grid sm:-mx-fluidMargin sm:px-fluidMargin md:mx-0 md:px-0">
          {secondaryContent && (
            <RichText
              className="md:col-span-8 md:col-start-2 lg:col-span-6 col-span-full lg:col-start-3"
              content={secondaryContent}
              size="small"
            />
          )}
          <div className="absolute bottom-0 left-0 hidden w-full md:block">
            <div className="absolute top-0 left-0 w-full h-px max-w-2xl transform -translate-x-16 bg-mineralGray" />
            <div className="absolute top-0 left-0 w-px transform -translate-y-6 bg-mineralGray h-15" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default InvestorRelations
